import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-57e61272"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "yams-layout" }
const _hoisted_2 = {
  id: "contentys",
  class: "content-wrapper"
}
const _hoisted_3 = {
  key: 0,
  class: "main-content"
}
const _hoisted_4 = {
  key: 1,
  class: "main-content"
}
const _hoisted_5 = { class: "header-contentys d-flex align-items-center" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_7 = {
  id: "page-content",
  class: "body-contentys overflow-auto"
}
const _hoisted_8 = { class: "container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TempSideBar = _resolveComponent("TempSideBar")!
  const _component_TempNavBar = _resolveComponent("TempNavBar")!
  const _component_TempFooter = _resolveComponent("TempFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_TempSideBar),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_TempNavBar),
      (_ctx.withoutHeader)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "content", {}, undefined, true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _renderSlot(_ctx.$slots, "header", {}, undefined, true)
            ]),
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _renderSlot(_ctx.$slots, "content", {}, undefined, true)
              ])
            ])
          ]))
    ]),
    _createVNode(_component_TempFooter)
  ]))
}